export default __webpack_public_path__ + "static/media/biometric-outline-16px.816a7837.svg";